import script from "./BookScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./BookScreen.vue?vue&type=script&setup=true&lang=js"

import "./BookScreen.vue?vue&type=style&index=0&id=77b92b30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77b92b30"]])

export default __exports__